// src/ErrorBoundaryWrapper.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const ErrorBoundaryWrapper = ({ children }) => {
  const location = useLocation();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(prev => prev + 1);
  }, [location.pathname]);

  return (
    <ErrorBoundary key={key} location={location}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
